import { render, staticRenderFns } from "./ChatEntries.vue?vue&type=template&id=06f03338&"
import script from "./ChatEntries.vue?vue&type=script&lang=js&"
export * from "./ChatEntries.vue?vue&type=script&lang=js&"
import style0 from "./ChatEntries.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports